module.exports = "<div class=\"modal\">\r\n  <div class=\"modal__header\">\r\n    {{ title }}\r\n  </div>\r\n  <div class=\"modal__content\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// G:/Projekty/swaythegame/src/app/shared-components/modal/modal.component.html
// module id = ../../../../../src/app/shared-components/modal/modal.component.html
// module chunks = main